export enum TSErrorType {
    CLIENT_SIDE = <any> 'CLIENT_SIDE',
    VALIDATION = <any> 'VALIDATION',
    INTERNAL = <any> 'INTERNAL',
    BADREQUEST = <any> 'BADREQUEST'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/TSErrorType.ts